import React, {Component} from 'react';
import {connect} from 'react-redux';
import { withTranslation } from 'react-i18next';
import Avatar from '../../../../../../../../../../components/avatar';
import {isDragging} from "../../../../../../../../../../../actions/dragNDropActions";
import {
    enteredContactSearchValue,
    selectedContacts,
    selectedContactFromDrag,
    contactValue,
    contactDetailsEditMode,
    isUpgradeToBusinessShown, userContactType, resetContactSearchResult
} from '../../../../../../../../../../../actions/contactActions';
import {guidedTours} from "../../../../../../../../../../../actions/guidedToursActions";
import {getSharingDetailsPopup} from "../../../../../../../../../../../actions/sharingDetailsActions";
import {contactContent} from '../../../../../../../../../../../actions/contactDetailsActions';
import {withRouter} from "react-router-dom";
import ContactActions from './components/contact-actions';
import {resetStates} from '../../../../../../../../../../../actions/contactsGroupItemActions';
import MoreContactButton from './components/contact-actions/components/more-contact-button';
import './index.css';

class Contact extends Component {

    constructor(props){
        super(props);

        this.state = {
            currentSelectedContact: []
        };

        this.mouseDownHandler = this.mouseDownHandler.bind(this);
        this.mouseMoveHandler = this.mouseMoveHandler.bind(this);
        this.mouseUpHandler = this.mouseUpHandler.bind(this);
        this.mouseEnterHandler = this.mouseEnterHandler.bind(this);
        this.mouseLeaveHandler = this.mouseLeaveHandler.bind(this);
        this.changeHandler = this.changeHandler.bind(this);
        this.handleContactDetails = this.handleContactDetails.bind(this);
    }

    mouseDown = false;
    mouseMove = false;
    mouseLeave = false;

    mouseDownHandler(e){

        if(e.target.className !== "custom-control-label"){

            this.mouseDown = true;

            e.currentTarget.addEventListener('mousemove', this.mouseMoveHandler);
            e.currentTarget.addEventListener('mouseup', this.mouseUpHandler);

            if(this.mouseLeave){
                this.mouseLeave = false;
            }

        }

    }

    mouseMoveHandler(e){

        this.mouseMove = true;

        if(this.mouseDown) {

            if(e.currentTarget.classList.contains('drag-n-drop') === false) {
                e.currentTarget.classList.add('drag-n-drop');
            }

            if(this.props.isDragging === false && this.mouseLeave === false && this.mouseDown){

                this.props.setIsDragging(true);

                if(this.props.selectedContacts.length > 0){

                    let dragAmongSelected = false;

                    this.props.selectedContacts.forEach(selectedItem => {

                        if(selectedItem.id === e.currentTarget.dataset.id){
                            dragAmongSelected = true;
                        }

                    });

                    if(dragAmongSelected){

                         /*
                         * If contacts checked before drag-n-drop and that contact the user drags is included
                         * */

                        this.props.setSelectedContactFromDrag(this.props.selectedContacts);

                    } else {

                        /*
                        * If the user drags a new contact that outside existing selected contacts, there is a new selection
                        * */

                        document.querySelectorAll(".contact .custom-control-input").forEach(item => item.checked = false);
                        e.currentTarget.children[0].children[0].children[0].checked = true;

                        this.props.setSelectedContactFromDrag([
                            {
                                'id' : e.currentTarget.dataset.id,
                                'type' : e.currentTarget.dataset.type ? e.currentTarget.dataset.type : 'contact',
                                'shareable' : e.currentTarget.dataset.shareable,
                                'deletable' : e.cTarget.dataset.deletable,
                                'editable'  : e.cTarget.dataset.editable
                            }
                        ]);

                    }

                } else {

                    e.currentTarget.children[0].children[0].children[0].checked = true;

                    this.props.setSelectedContactFromDrag([
                        {
                            'id' : e.currentTarget.dataset.id,
                            'type' : e.currentTarget.dataset.type ? e.currentTarget.dataset.type : 'contact',
                            'shareable' : e.currentTarget.dataset.shareable,
                            'deletable' : e.currentTarget.dataset.deletable,
                            'editable'  : e.currentTarget.dataset.editable
                        }
                    ]);
                }


            }

        }
    }

    mouseUpHandler(e){

        /*
        * e.stopPropagation() to avoid the parent function mouseUpHandler of Sharing component to be triggered
        * */

        e.stopPropagation();

        if(e.target.className !== "custom-control-label"){

            e.currentTarget.removeEventListener('mousemove', this.mouseMoveHandler);

            this.mouseDown = false;

            if(this.props.isDragging && this.mouseMove){
                this.props.setIsDragging(false);

                e.currentTarget.children[0].children[0].children[0].checked = false;
                this.props.setSelectedContactFromDrag([]);

                document.querySelectorAll(".contact .custom-control-input").forEach(item => {

                    this.props.selectedContacts.forEach(contact => {
                        if (item.dataset.id === contact.id) {
                            item.checked = true;
                        }
                    });

                });

                //this.props.setSelectedContact([]);

            }

            if(e.currentTarget.classList.contains('drag-n-drop')){
                e.currentTarget.classList.remove('drag-n-drop');
            }

        }

    }

    mouseEnterHandler(){
        /*if(this.props.isDragging){
            this.props.setIsDragging(false);
        }*/
    }

    mouseLeaveHandler(e){
        this.mouseLeave = true;
        e.currentTarget.removeEventListener('mousemove', this.mouseMoveHandler);
        e.currentTarget.removeEventListener('mouseup', this.mouseUpHandler);
        this.mouseDown = false;
    }

	changeHandler(e){

        let cTarget = e.currentTarget;

        if(cTarget.checked){
            this.props.setSelectedContacts([
                ...this.props.selectedContacts,
                {
                    'id' : cTarget.dataset.id,
                    'email' : cTarget.dataset.email || "",
                    'type' : cTarget.dataset.type ? cTarget.dataset.type : 'contact',
                    'shareable' : cTarget.dataset.shareable,
                    'deletable' : cTarget.dataset.deletable,
                    'editable'  : cTarget.dataset.editable
                }
            ]);

            if(document.getElementById('t1') && this.props.guidedTours.t1 === false){
                document.getElementById('t1').style.transform = "scale(0)";

                setTimeout(() => {
                    this.props.setGuidedTours({
                        't1': true
                    });
                }, 250)
            }

        } else {
            this.props.setSelectedContacts(this.props.selectedContacts.filter(item => item.id !== cTarget.dataset.id));
        }
        setTimeout(()=>{
            document.getElementById('massContactsSelection').checked = this.props.selectedContacts.length === this.props.findContacts.contacts.length;
        })

    }

    handleContactDetails(){

        this.props.setUserContactType(this.props.type);

        this.props.enteredContactSearchValue("");
        this.props.resetContactSearchResult();

        if(this.props.previewMode){
            return;
        }

        if(this.props.checkGmailAddOnData.action==='addToAContact'){
            this.props.setContactDetailsEditMode(true);
            this.props.getSharingDetailsPopup([true, 'gmail_contact_details',[{id: this.props.id, type: this.props.type}]]);
        } else {
            this.props.history.push(`/contact/${this.props.id}`);
        }

    }

    render() {

        return (
            <div className={`contact${this.props.previewMode ? ' preview-mode' :''}`}
                 onMouseDown={this.mouseDownHandler}
                 onMouseEnter={this.mouseEnterHandler}
                 onMouseLeave={this.mouseLeaveHandler}
                 id={this.props.id ? `contact-${this.props.id}` : null}
                 key={this.props.id}
                 data-id={this.props.id}
                 data-type={this.props.type}
                 data-shareable={this.props.shareable}
                 data-editable={this.props.editable}
                 data-deletable={this.props.deletable}
                 onClick={this.handleContactDetails}
                 style={this.props.rowStyle}
            >
	            <MoreContactButton
		            contactId={this.props.id}
		            contactName={this.props.name}
		            contactEmail={this.props.email}
		            contactType={this.props.type}
		            editable={this.props.editable}
		            deletable={this.props.deletable}
		            shareable={this.props.shareable}
		            history={this.props.history}
		            fromAutocomplete={this.props.fromAutocomplete}
	            />
                <div className="contact-body d-flex align-items-center">
	                <div className="d-flex align-items-center col-5">
		                <div className="d-flex position-relative">
			                {
				                this.props.searchResults
					                ?
					                null
					                :
					                this.props.checkGmailAddOnData.action==='addToAContact'
						                ?
						                ''
						                :
						                <div className="custom-control custom-checkbox my-1 mr-1 mr-sm-2">
							                <input
								                defaultChecked={this.props.selectedContacts.find(item => item.id === this.props.id)}
								                type="checkbox"
								                data-id={this.props.id}
								                data-email={this.props.email}
								                data-type={this.props.type}
								                data-shareable={this.props.shareable}
								                data-editable={this.props.editable}
								                data-deletable={this.props.deletable}
								                onClick={(e) => e.stopPropagation()}
								                onChange={this.changeHandler}
								                className="custom-control-input"
								                id={`contact-checkbox-${this.props.id}`}
								                disabled={!this.props.editable && !this.props.deletable ? true : false}
							                />
							                <label onClick={(e) => e.stopPropagation()} className="custom-control-label" htmlFor={`contact-checkbox-${this.props.id}`}/>
						                </div>
			                }
			                {
				                this.props.hasImage
					                ?
					                <Avatar
						                size={48}
						                className="border-0"
						                src={`data:image/png;base64,${this.props.picture}`}
						                draggable={false}
					                />
					                :
					                this.props.picture !== ''
						                ?
						                <Avatar
							                size={48}
							                className="border-0"
							                src={this.props.picture}
							                draggable={false}
						                />
						                :
						                <Avatar
							                size={48}
							                className="border-0"
							                src={`https://lh3.googleusercontent.com/a/default-user=s200-p-k-rw-no`}
							                draggable={false}
						                />

			                }
			                {
				                this.props.type === "directory"
					                ?
					                <svg className="directory-contact-icon" xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" xmlSpace="preserve">
						                <path fill="#001593" d="M24 0C10.745 0 0 10.745 0 24c0 13.255 10.745 24 24 24 13.255 0 24 -10.745 24 -24C48 10.745 37.255 0 24 0z"/>
						                <path d="M11.654 13.708h2.483v25.362h-2.483zm22.209 0h2.482v25.362h-2.482zm-18.284 25.362H20.554V34.673h6.892v4.397h4.974V8.93H15.579v30.139zm12.907 -28.126h2.487v2.764h-2.487v-2.764zm0 4.249h2.487v2.758h-2.487v-2.758zm0 4.243h2.487v2.764h-2.487v-2.764zm0 4.249h2.487v2.764h-2.487v-2.764zm0 4.778h2.487v2.758h-2.487v-2.758zm-3.82 -17.519h2.487v2.764h-2.487v-2.764zm0 4.249h2.487v2.758h-2.487v-2.758zm0 4.243h2.487v2.764h-2.487v-2.764zm0 4.249h2.487v2.764h-2.487v-2.764zm0 4.778h2.487v2.758h-2.487v-2.758zm-3.82 -17.519h2.483v2.764h-2.483v-2.764zm0 4.249h2.483v2.758h-2.483v-2.758zm0 4.243h2.483v2.764h-2.483v-2.764zm0 4.249h2.483v2.764h-2.483v-2.764zm0 4.778h2.483v2.758h-2.483v-2.758zm-3.825 -17.519h2.483v2.764h-2.483v-2.764zm0 4.249h2.483v2.758h-2.483v-2.758zm0 4.243h2.483v2.764h-2.483v-2.764zm0 4.249h2.483v2.764h-2.483v-2.764zm0 4.778h2.483v2.758h-2.483v-2.758z" fill="#FFF"/>
					                </svg>
					                :
					                null
			                }
		                </div>
		                <div className="overflow-hidden mr-2">
			                {
				                this.props.name
					                ?
					                <p className="contact-name m-0 text-nowrap text-truncate" data-id={this.props.id}>
						                <strong>{this.props.name}</strong>
					                </p>
					                :
					                ''
			                }
			                {
				                this.props.company && (this.props.name !== this.props.company)
					                ?
					                <p className="contact-email text-truncate" title={this.props.company}>
						                {this.props.company}
					                </p>
					                :
					                this.props.jobTitle
						                ?
						                <p className="contact-email text-truncate" title={this.props.jobTitle}>
							                {this.props.jobTitle}
						                </p>
						                :
						                this.props.emails && this.props.email && (this.props.name !== this.props.email)
							                ?
							                <p className="contact-email text-truncate" title={this.props.emails.join(', ')}>
								                {this.props.email}
							                </p>
							                :
							                this.props.email && (this.props.name !== this.props.email)
								                ?
								                <p className="contact-email text-truncate" title={this.props.email}>
									                {this.props.email}
								                </p>
								                :
								                (this.props.name !== this.props.phoneNumber) && this.props.phoneNumber
									                ?
									                <p className="contact-email text-truncate" title={this.props.phoneNumber}>
										                {this.props.phoneNumber}
									                </p>
									                :
									                ''
			                }
			                {
				                (this.props.name !== this.props.company) && this.props.company && this.props.jobTitle
					                ?
					                <p className="contact-email text-truncate" title={this.props.jobTitle}>
						                {this.props.jobTitle}
					                </p>
					                :
					                this.props.jobTitle && this.props.emails && this.props.email && (this.props.name !== this.props.email)
						                ?
						                <p className="contact-email text-truncate" title={this.props.emails.join(', ')}>
							                {this.props.email}
						                </p>
						                :
						                this.props.email && (this.props.name !== this.props.email) && this.props.email && this.props.phoneNumber
							                ?
							                <p className="contact-email text-truncate" title={this.props.phoneNumber}>
								                {this.props.phoneNumber}
							                </p>
							                :
							                ''
			                }
                            {
                                this.props.department && <span className="my-2 font-weight-normal border badge badge-pill badge-light">
                                    {this.props.department}
                                </span>
                            }
		                </div>
	                </div>
	                <div className="col-7 h-100 d-flex flex-column overflow-hidden">
                        {
	                        this.props.labels.length > 0 && <div className="mb-1 mr-3">
		                        {
			                        this.props.labels.map((group) => (
				                        <span key={group.id} className="small mr-2">
                                            <svg className="mr-1" width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M0.93183 7.73196C0.675559 7.73196 0.456186 7.64072 0.273711 7.45825C0.0912371 7.27577 0 7.0564 0 6.80013V0.93183C0 0.675558 0.0912371 0.456185 0.273711 0.273711C0.456186 0.091237 0.675559 0 0.93183 0H6.39871C6.54622 0 6.686 0.0325604 6.81804 0.0976806C6.95 0.162801 7.05868 0.252835 7.14407 0.367783L9.79382 3.86598L7.14407 7.36418C7.05868 7.47912 6.95 7.56916 6.81804 7.63428C6.686 7.6994 6.54622 7.73196 6.39871 7.73196H0.93183ZM0.93183 6.95876H6.39871C6.42517 6.95876 6.44914 6.95382 6.47062 6.94394C6.4921 6.93398 6.51109 6.91907 6.52758 6.89923L8.82732 3.86598L6.52758 0.832732C6.51109 0.812887 6.4921 0.797982 6.47062 0.788016C6.44914 0.778136 6.42517 0.773196 6.39871 0.773196H0.93183C0.885524 0.773196 0.847509 0.788059 0.817784 0.817784C0.788059 0.847509 0.773196 0.885524 0.773196 0.93183V6.80013C0.773196 6.84644 0.788059 6.88445 0.817784 6.91418C0.847509 6.9439 0.885524 6.95876 0.93183 6.95876Z" fill="#67C965"/>
                                            </svg>
                                                {group.name}
                                        </span>
			                        ))
		                        }
	                        </div>
                        }
		                <div className="font-italic h-100 overflow-auto mr-3" onScroll={(e) => e.stopPropagation()}>
			                {this.props.note}
		                </div>
	                </div>
                </div>
                <div className="contact-footer d-flex">
                    {
	                    this.props.lastComment && <div className="p-0 d-flex align-items-center overflow-hidden">
		                    <Avatar
			                    size={24}
			                    className="border-0 m-0 mr-2"
			                    src={this.props.lastComment.pictureUrl}
			                    draggable={false}
		                    />
		                    <p className="last-comment text-truncate small font-italic">
			                    {this.props.lastComment.comment}
		                    </p>
	                    </div>
                    }
	                {
		                !this.props.previewMode
		                && this.props.checkGmailAddOnData?.action !== 'addToAContact'
		                && <div className="ml-auto p-0"><ContactActions
			                id={this.props.id}
			                name={this.props.name}
			                type={this.props.type}
			                deletable={this.props.deletable}
			                editable={this.props.editable}
			                shareable={this.props.shareable}
			                phoneNumber={this.props.phoneNumber}
			                email={this.props.email}
			                history={this.props.history}
			                fromAutocomplete={this.props.fromAutocomplete}
		                /></div>
	                }
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        selectedContactsGroup: state.contactsGroupItemReducer.getSelectedContactsGroup,
        isDragging: state.dragNDropReducer.isDragging,
        findLabels:  state.contactsGroupItemReducer.findLabels,
        selectedContacts: state.contactReducer.selectedContacts,
        findContacts: state.contactReducer.findContacts,
        guidedTours: state.guidedToursReducer.guidedTours,
        checkGmailAddOnData: state.profileReducer.setGmailAddOnData,
        hasContactsManagementPermission: state.permissionReducer.hasContactsManagementPermission
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setIsDragging : (object) => {
            dispatch(isDragging(object))
        },
	    setSelectedContacts : (array) => {
		    dispatch(selectedContacts(array))
	    },
        setSelectedContactFromDrag : (array) => {
            dispatch(selectedContactFromDrag(array))
        },
        setEnteredContactSearchValue: (string) => {
            dispatch(enteredContactSearchValue(string))
        },
        setContactDetailsEditMode: (boolean) => {
            dispatch(contactDetailsEditMode(boolean))
        },
        setGuidedTours : (object) => {
            dispatch(guidedTours(object))
        },
        getSharingDetailsPopup: (array) => {
            dispatch(getSharingDetailsPopup(array))
        },
        setContactValue: (string) =>  {
            dispatch(contactValue(string))
        },
	    setContactContent: (string) =>  {
            dispatch(contactContent(string))
        },
        setIsUpgradeToBusinessShown: (boolean) => {
            dispatch(isUpgradeToBusinessShown(boolean))
        },
	    setUserContactType: (string) =>  {
		    dispatch(userContactType(string))
	    },
	    resetStates: () => {
		    dispatch(resetStates())
	    },
        enteredContactSearchValue: (string) => {
            dispatch(enteredContactSearchValue(string))
        },
        resetContactSearchResult: () => {
            dispatch(resetContactSearchResult())
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withTranslation()(Contact)));
